<form class="filter" #formElement [formGroup]="form">
    <mat-form-field class="full-width">
        <mat-select formControlName="medicalFeePeriodFilter" placeholder="Período" required>
            <mat-option *ngFor="let medicalFeePeriodFilter of medicalFeePeriodFilters" [value]="medicalFeePeriodFilter">
                {{ medicalFeePeriodFilter.Name }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="f.medicalFeePeriodFilter.errors && f.medicalFeePeriodFilter.errors.required">
            Seleccione un período
        </mat-error>
    </mat-form-field>
</form>